import React from 'react';

import {Typography} from './typography.component';

import type {TypographyProps} from './typography.component';
import type {ElementType} from 'react';


export type OmittedTypographyProps<T extends ElementType> = Omit<TypographyProps<T>, 'as' | 'variant'>;

export const H1 = (props: OmittedTypographyProps<'h1'>) => (
    <Typography
        as="h1"
        variant="heading-level-1"
        {...props}>
        {props.children}
    </Typography>
);

export const H2 = (props: OmittedTypographyProps<'h2'>) => (
    <Typography
        as="h2"
        variant="heading-level-2"
        {...props}>
        {props.children}
    </Typography>
);

export const H3 = (props: OmittedTypographyProps<'h3'>) => (
    <Typography
        as="h3"
        variant="heading-level-3"
        {...props}>
        {props.children}
    </Typography>
);

export const H4 = (props: OmittedTypographyProps<'h4'>) => (
    <Typography
        as="h4"
        variant="heading-level-4"
        {...props}>
        {props.children}
    </Typography>
);

export const H5 = (props: OmittedTypographyProps<'h5'>) => (
    <Typography
        as="h5"
        variant="heading-level-5"
        {...props}>
        {props.children}
    </Typography>
);

export const H6 = (props: OmittedTypographyProps<'h6'>) => (
    <Typography
        as="h6"
        variant="heading-level-6"
        {...props}>
        {props.children}
    </Typography>
);

